import {z} from 'zod';

import {BaseVoidRequestSchema, BaseVoidResponseSchema} from '@dms/api/shared';

const LabourRateSchema = z.object({
  labourRateId: z.string().nullable().optional(),
  authorizationProfileIds: z.array(z.string().nullable()).optional(),
  name: z.string().nullable().optional(),
  rateTypes: z.array(z.string().nullable()).optional(),
  rateUnitPriceWithoutVat: z.number().nullable().optional(),
  currency: z.string().nullable().optional(),
  workTypeIds: z.array(z.string().nullable()).optional(),
  vehicleGroupIds: z.array(z.string().nullable()).optional(),
  vehicleClassIds: z.array(z.string().nullable()).optional(),
  vehicleFuelTypes: z.array(z.string().nullable()).optional(),
  isActive: z.boolean(),
});

export const LabourRateApiResponseSchema = LabourRateSchema.nullable();

export type PostLabourRateApiResponse = z.infer<typeof LabourRateApiResponseSchema>;
export type GetLabourRateApiResponse = z.infer<typeof LabourRateApiResponseSchema>;
export type PatchLabourRateApiResponse = z.infer<typeof LabourRateApiResponseSchema>;

export const PostLabourRateApiArgSchema = z.object({
  body: z
    .object({
      authorizationProfileIds: z.array(z.string()),
      name: z.string(),
      rateTypes: z.array(z.string()),
      rateUnitPriceWithoutVat: z.number(),
      currency: z.string(),
      workTypeIds: z.array(z.string().nullable()).optional(),
      vehicleGroupIds: z.array(z.string().nullable()).optional(),
      vehicleClassIds: z.array(z.string().nullable()).optional(),
      vehicleFuelTypes: z.array(z.string().nullable()).optional(),
      isActive: z.boolean(),
    })
    .nullable(),
});

export type PostLabourRateApiArg = z.infer<typeof PostLabourRateApiArgSchema>;

export const GetLabourRateApiArgSchema = z.object({
  labourRateId: z.string(),
});

export type GetLabourRateApiArg = z.infer<typeof GetLabourRateApiArgSchema>;

export const PatchLabourRateApiArgSchema = z.object({
  labourRateId: z.string(),
  body: z
    .object({
      authorizationProfileIds: z.array(z.string()),
      name: z.string(),
      rateTypes: z.array(z.string()),
      rateUnitPriceWithoutVat: z.number(),
      currency: z.string(),
      workTypeIds: z.array(z.string().nullable()).optional(),
      vehicleGroupIds: z.array(z.string().nullable()).optional(),
      vehicleClassIds: z.array(z.string().nullable()).optional(),
      vehicleFuelTypes: z.array(z.string().nullable()).optional(),
      isActive: z.boolean(),
    })
    .nullable(),
});

export type PatchLabourRateApiArg = z.infer<typeof PatchLabourRateApiArgSchema>;

export type DeleteLabourRateApiResponse = z.infer<typeof BaseVoidResponseSchema>;
export type PostLabourRateSetAsActiveApiResponse = z.infer<typeof BaseVoidResponseSchema>;
export type PostLabourRateSetAsInActiveApiResponse = z.infer<typeof BaseVoidResponseSchema>;

export const DeleteLabourRateApiArgSchema = z.object({
  labourRateId: z.string(),
});

export type DeleteLabourRateApiArg = z.infer<typeof DeleteLabourRateApiArgSchema>;

export const PostLabourRateSetAsActiveApiArgSchema = z.object({
  labourRateId: z.string(),
});
export type PostLabourRateSetAsActiveApiArg = z.infer<typeof PostLabourRateSetAsActiveApiArgSchema>;

export const PostLabourRateSetAsInActiveApiArgSchema = z.object({
  labourRateId: z.string(),
});
export type PostLabourRateSetAsInActiveApiArg = z.infer<
  typeof PostLabourRateSetAsInActiveApiArgSchema
>;

export const GetLabourRatesListApiArgSchema = z.object({
  serviceCaseId: z.string(),
  serviceOrderId: z.string(),
});
export type GetLabourRatesListApiArg = z.infer<typeof GetLabourRatesListApiArgSchema>;

const LabourRateListItemSchema = z.object({
  labourRateId: z.string(),
  name: z.string(),
  rateValue: z.object({
    withoutVat: z.object({
      amount: z.number(),
      currency: z.string(),
    }),
  }),
});

export const LabourRatesListApiResponseSchema = z.array(LabourRateListItemSchema).nullable();

export type GetLabourRatesListApiResponse = z.infer<typeof LabourRatesListApiResponseSchema>;

export type LabourRateListItem = z.infer<typeof LabourRateListItemSchema>;

export const GetHourlyRatesListApiArgSchema = BaseVoidRequestSchema;
export type GetHourlyRatesListApiArg = z.infer<typeof GetHourlyRatesListApiArgSchema>;

export const GetHourlyRatesListApiResponseSchema = z.array(LabourRateSchema);
export type GetHourlyRatesListApiResponse = z.infer<typeof GetHourlyRatesListApiResponseSchema>;
